<template>
  <div id="go-top" v-show="isShow" @click="goTop()">
    <img class="img1" src="@/assets/image/go-top.png" alt="">
    <img class="img2" src="@/assets/image/go-top-hover.png" alt="">
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isShow: false
      }
    },
    mounted() {
      const _this = this
      window.addEventListener('scroll', function () {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        if (scrollTop > _this.initScroll()) {
          _this.isShow = true
        } else {
          _this.isShow = false
        }
      })
    },
    methods: {
      initScroll() {
        var clientHeight = 0;
        if (document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
        }
        else {
          clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
        }
        return clientHeight;
      },
      goTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }
    }
  }
</script>
<style lang='scss' scoped>
  #go-top {
    cursor: pointer;
    height: 70px;
    width: 70px;
    padding: 9px;
    position: fixed;
    bottom: 5%;
    right: 0px;

    &:hover {
      .img1 {
        display: none;
      }

      .img2 {
        display: block;
      }
    }

    img {
      height: 100%;
      width: 100%;
      border: none;
    }

    .img2 {
      display: none;
    }
  }
</style>